import { createModel } from 'models/BaseModel';
import {
  getLevelDiscountList,
  getLevelDiscount,
  updateLevelDiscount,
  updateLevelBenefits,
} from 'services/LevelAPIHelper';
import { LanguageConfig, SESSION_KEYS } from 'config/CustomEnums';
import { getDetailPageDisplayLastModifiedDate, getListDisplayLastModifiedDate } from 'utils/TimeFormatUtil';
import { getDisplayLastModifiedBy } from 'utils';
import { cleanTranslations } from './LevelModel';
import { apiWithResponseHandle } from './LoadingUtil';

const parseSingleLevelBenefit = (item) => {
  const translationsEdges = item.translations?.edges;
  let translations = {};
  translations[LanguageConfig.english] = {
    language: LanguageConfig.english,
    title: item.title,
    content: item.content,
  }
  if (translationsEdges?.length > 0) {
    translationsEdges.forEach((item) => {
      const node = item.node;
      translations[node.language] = node;
    });
  }

  return {
    id: item.pk,
    pk: item.pk,
    title: item.title,
    content: item.content,
    highlight: item.highlight,
    displayOrder: item.displayOrder,
    translations,
  };
};

const parseLevelBenefits = (data) => {
  if (!data) {
    return [];
  };
  return data.map((item) => {
    return parseSingleLevelBenefit(item);
  });
}

const cleanLevelBenefits = (data) => {
  if (!data) {
    return [];
  }

  return data?.map((item, index) => {
    const formattedTranslation = cleanTranslations(
      item,
      LanguageConfig.english,
      ['title', 'content']
    );

    const otherTranslations = [];
    Object.keys(item?.translations || {}).forEach((language) => {
      if (language === LanguageConfig.english) {
        return;
      }
      otherTranslations.push(
        cleanTranslations(item, language, ['title', 'content']),
      );
    });

    const result = {
      highlight: item.highlight,
      displayOrder: index + 1,
      translations: otherTranslations,
      ...formattedTranslation,
    }

    if (item.pk) {
      result["id"] = item.pk;
    }

    return result;
  })
};

const parseDetail = (data) => {
  const parsedData = {
    ...data,
    sourceName: data.level.levelName,
    name: data.level.levelName,
    displayDiscount: `${Number(data.discount) * 100}%`,
    displayShopifyFreeDelivery: data.freeDeliveryOnShopfify ? 'Yes' : 'No',
    discountNumber: Number(data.discount) * 100,
    listDisplayLastModifiedTime: getListDisplayLastModifiedDate(data?.lastModifiedDate),
    detailDisplayCreationDate: getDetailPageDisplayLastModifiedDate(data?.creationDate),
    detailDisplayLastModifiedTime: getDetailPageDisplayLastModifiedDate(data?.lastModifiedDate),
    displayLastModifiedBy: getDisplayLastModifiedBy(data),
    levelBenefits: parseLevelBenefits(data.levelBenefits),
  };
  return parsedData;
};

export default createModel({
  namespace: 'levelDiscount',
  states: {
    listDisplayFields: [
      { displayName: 'ID', fieldName: 'pk', orderField: 'pk', linked: true },
      {
        displayName: 'Level',
        fieldName: 'name',
      },
      {
        displayName: 'Discount',
        fieldName: 'displayDiscount',
      },
      {
        displayName: 'Shopify - free delivery',
        fieldName: 'displayShopifyFreeDelivery',
      },
      { displayName: 'Last modified time', fieldName: 'listDisplayLastModifiedTime' },
    ],
    detail: {
      sourceName: '',
      discount: '',
    },
  },
  reducers: {},
  params: {
    sessionKey: SESSION_KEYS.LEVEL_DISCOUNT_SESSION_KEY,
    dataKey: SESSION_KEYS.LEVEL_DISCOUNT_DATA_SESSION_KEY,
    listAPI: getLevelDiscountList,
    parse: (data) => data?.levelDiscounts.edges.map((item) => parseDetail(item.node)),
    pkNode: 'LevelDiscountNode',
    detailAPI: getLevelDiscount,
    parseDetail: (data) => parseDetail(data.levelDiscount),
    objectKey: 'levelDiscount'
  },
  effects: {
    createOrUpdate: [
      function* ({ payload }, { call, select, put }) {
        console.log("@56", payload)
        const data = {
          id: payload.pk,
          discount: Number(payload.discountNumber) / 100.0,
          freeDeliveryOnShopfify: payload.freeDeliveryOnShopfify || false,
        };
        const serviceArgs = [updateLevelDiscount, data];
        yield put({
          type: 'responseCreateOrUpdate',
          payload: { serviceArgs, isCreate: false },
        });

        yield put({
          type: 'updateLevelBenefits',
          payload: {
            levelId: payload?.level?.pk,
            levelBenefits: payload?.levelBenefits,
          }
        })

      },
      { type: 'takeLatest' },
    ],

    updateLevelBenefits: [
      function* ({ payload }, { call, select, put }) {
        const updatePayload = {
          levelId: payload?.levelId,
          levelBenefits: cleanLevelBenefits(payload?.levelBenefits),
        };
        const serviceArgs = [updateLevelBenefits, updatePayload];
        function onSuccess(data) {
          console.log("@@updateLevelBenefits", data);
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
});
